"use client";

import { useEffect } from "react";
import { GlassCard } from "@/components/design-system/GlassCard";
import { CyberButton } from "@/components/design-system/CyberButton";
import { HolographicText } from "@/components/design-system/HolographicText";
import { AlertTriangle, RefreshCcw } from "lucide-react";

export default function RegisterError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[Register Error]", error);
  }, [error]);

  return (
    <GlassCard variant="strong" padding="lg" className="border-neon-red/20">
      <div className="flex flex-col items-center text-center mb-6">
        <div className="w-14 h-14 rounded-2xl bg-neon-red/10 border border-neon-red/20 flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(255,7,58,0.15)]">
          <AlertTriangle className="w-7 h-7 text-neon-red" />
        </div>
        <HolographicText as="h2" className="text-lg mb-2">
          Registration Error
        </HolographicText>
        <p className="text-sm text-white/40 max-w-sm">
          Something went wrong with the registration page. Please try again.
        </p>
      </div>

      <div className="rounded-lg bg-neon-red/5 border border-neon-red/10 px-4 py-3 mb-6">
        <p className="text-xs font-mono text-neon-red/80 break-all">
          {error.message || "An unexpected error occurred"}
        </p>
      </div>

      <CyberButton
        color="cyan"
        size="md"
        fullWidth
        icon={<RefreshCcw className="w-4 h-4" />}
        onClick={reset}
      >
        Try Again
      </CyberButton>
    </GlassCard>
  );
}
